import {
  navigateShell,
  type NavigateShellContext,
  type NavigateShellOptions,
  type ShellIonRouter,
} from '@/core/lib/navigate-shell';
import { resolveNotificationDeepLink } from '@/core/lib/notification-deep-link';

export type { ShellIonRouter } from '@/core/lib/navigate-shell';

/**
 * Navigate to an in-shell path or notification deep link (cold entry).
 * Detail routes seed the parent list route first when needed.
 */
export async function navigateShellDeepLink(
  router: ShellIonRouter,
  pathOrDeepLink: string,
  context: NavigateShellContext,
  options?: Omit<NavigateShellOptions, 'coldLink'>,
): Promise<void> {
  const resolved = resolveNotificationDeepLink(pathOrDeepLink);
  await navigateShell(router, resolved, context, {
    ...options,
    coldLink: true,
  });
}
